// ============================================================
// HitProbabilityChart - P(N hits) bar chart with expected value.
// ============================================================
import BarChart from './BarChart';
import type { HitDistribution } from '../../engine/probability';

interface Props {
  data: HitDistribution;
}

export default function HitProbabilityChart({ data }: Props) {
  const bars = data.probabilities.map((p, i) => ({
    label: String(i),
    value: p,
    color: i === 0 ? '#ef4444' : '#c4a35a',
  }));

  return (
    <BarChart
      data={bars}
      barColor="#c4a35a"
      showValues
      formatValue={(v) => (v * 100).toFixed(0) + '%'}
      annotationValue={undefined}
      maxValue={1}
    />
  );
}
